import WidgetPlaceholder from "./WidgetPlaceholder";
import DashboardTable from "../table/DashboardTable";

type DataRow = Record<string, unknown>;

type DataTableWidgetProps = {
  isLoading: boolean;
  data: unknown;
};

export default function DataTableWidget({
  isLoading,
  data,
}: DataTableWidgetProps) {
  const reportData: DataRow[] = Array.isArray(data) ? (data as DataRow[]) : [];
  const reportHeader = reportData[0] ? Object.keys(reportData[0]) : [];

  return isLoading ? (
    <WidgetPlaceholder height={48} />
  ) : (
    <DashboardTable
      isReportLoading={isLoading}
      reportHeader={reportHeader}
      reportData={reportData}
    />
  );
}
